module.exports = __webpack_public_path__ + "static/media/image-card-3.8e7162bf.png";